import { render } from "./linkOrderDetail.vue?vue&type=template&id=7a07f556&scoped=true"
import script from "./linkOrderDetail.vue?vue&type=script&lang=js"
export * from "./linkOrderDetail.vue?vue&type=script&lang=js"

import "./linkOrderDetail.vue?vue&type=style&index=0&id=7a07f556&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7a07f556"

export default script